import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal } from '../elements-modal/modal';
import { SearchModal } from './search-modal';

export class LocationModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      location: null,
      nickname: null
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.locationModalBody = this.locationModalBody.bind(this);
    this.closeBehavior = this.closeBehavior.bind(this);
    this.handleListClick = this.handleListClick.bind(this);
  }

  componentDidMount () {
    if (this.props.closeDropdown) {
      analyticsIntegrations.locationModal(this.props.origin);
      this.props.closeDropdown();
    }
  }

  handleClickOutside () {
    this.setState({ isOpened: false });
  }

  locationModalBody () {
    const { metros } = this.props;
    const activeMetros = _.filter(metros, { active: true });
    const continents = _.groupBy(activeMetros, (metro) => {
      if ('US' === metro.country) {
        return 'United States';
      }
      if ('CA' === metro.country) {
        return 'Canada';
      }
      return 'Europe';
    });
    return (<div className="container-fluid">
      {_.map(continents, (continent, key) => {
        return (
          <div key={key} className="row">
            <div className="col-xs-12">
              <h5>{key}</h5>
              <hr/>
            </div>
            { _.map(_.chunk(continent, 4), (metroArr, i) => {
              return (
                <div key={`continent_${i}`}className="col-xs-6 col-sm-4">
                  <ul>
                    { _.map(metroArr, (metro, i) => {
                      const name = metro.name;
                      if (!this.props.searchLink) {
                        return (<li key={`metro_${i}`}>
                          <a
                            onClick={this.handleListClick}
                            data-value={metro.nickname}
                            data-geo={metro.map_boundaries}
                            data-active={metro.active}
                            data-name={name}
                            href="#"
                          >{name}</a>
                        </li>);
                      }
                      return (<li key={`metro_${i}`}>
                        <a href={this.props.searchLink(name, this.props.useType)}>{name}</a>
                      </li>);
                    })}
                  </ul>
                </div>
              );
            }) }
          </div>
        );
      })}
    </div>);
  }

  closeBehavior (e) {
    if (e) {
      $('#modal-container').modal('hide');
      return ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    }
    return ReactDOM.render(<SearchModal location={this.state.location} nickname={this.state.nickname}/>, document.getElementById('modal-container'));
  }

  handleListClick (e) {
    window.scrollTo(0, 0);
    if ('modal' !== this.props.origin) {
      if (!this.props.handleLocationClick) {
        return;
      } else {
        this.props.handleLocationClick(e);
        return this.closeBehavior(e);
      }
    }
    this.setState({
      location: $(e.currentTarget).attr('data-name'),
      nickname: $(e.currentTarget).attr('data-value')
    }, () => {
      return this.closeBehavior();
    });
  }

  render () {
    return (<Modal
      show
      addCloseIcon
      modalType="standard"
      modalID="location-modal"
      modalSize={'lg-size'}
      body={ this.locationModalBody() }
      header="Peerspace Locations"
      footer={null}
      closeBehavior={this.closeBehavior}
    />);
  }
}

LocationModal.propTypes = {
  listing: PropTypes.object,
  user: PropTypes.object,
  closeDropdown: PropTypes.func,
  searchLink: PropTypes.func,
  useType: PropTypes.string,
  origin: PropTypes.string
};
